export default __webpack_public_path__ + "static/media/marker_filled_yellow_light.aa91d592.svg";